<button
  appButton
  name="close"
  location="website-mobile-menu"
  [iconButton]="true"
  color="simple"
  (click)="close()"
  class="close-button"
>
  <app-svg src="/assets/icons/cross.svg"></app-svg>
  <div class="button-hitbox-extender"></div>
</button>
<img src="/assets/picflow-icon.svg" alt="" width="48" height="48" class="logo-icon" />
<div class="menu-buttons">
  @for (item of menuStructure; track item) {
    @if (item.component === 'MenuItem') {
      <a
        [routerLink]="['/', item.link.cached_url]"
        (click)="close()"
        appButton
        name="{{ item.text | lowercase }}"
        location="website-mobile-menu"
        color="simple"
        weight="bold"
        spacing="full"
        size="4"
        >{{ item.text }}</a
      >
    } @else {
      <div
        appButton
        name="{{ item.text | lowercase }}"
        location="website-mobile-menu"
        color="simple"
        weight="bold"
        spacing="full"
        size="4"
        (click)="dropdownStates[item.text] = !dropdownStates[item.text]"
      >
        <span>{{ item.text }}</span>
        <app-svg src="/assets/icons/16/arrow-down.svg" size="-1"></app-svg>
      </div>
      @if (dropdownStates[item.text]) {
        <div [@featuresMenu] class="features-menu">
          @for (subItem of item.buttons; track subItem) {
            @if (subItem.link.linktype === 'story') {
              <a
                [routerLink]="['/', subItem.link.cached_url]"
                (click)="close()"
                appButton
                name="{{ subItem.text | lowercase }}"
                location="website-mobile-menu"
                height="0-5"
                color="simple-gray"
                spacing="full"
                >{{ subItem.text }}</a
              >
            } @else {
              <a
                [href]="subItem.link.url"
                target="_blank"
                (click)="close()"
                appButton
                name="{{ subItem.text | lowercase }}"
                location="website-mobile-menu"
                height="0-5"
                color="simple-gray"
                spacing="full"
                >{{ subItem.text }}</a
              >
            }
          }
        </div>
      }
    }
  }
  <div class="buttons">
    <a
      appButton
      name="login"
      location="website-mobile-menu"
      routerLink="/auth/login"
      spacing="full"
      (click)="close()"
      weight="bold"
    >
      Log in
    </a>
    <a
      appButton
      name="signup"
      location="website-mobile-menu"
      routerLink="/auth/signup"
      spacing="full"
      (click)="close()"
      color="primary"
      >Try for Free</a
    >
  </div>
</div>
